import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ConfirmModalComponent } from '../../../components/confirm-modal/confirm-modal.component';
import { SelfServiceService } from '../../../../services/self-service.service';

@Component({
  selector: 'app-cancel-transfer-booking',
  imports: [TranslocoModule],
  templateUrl: './cancel-transfer-booking.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cancel-transfer-booking.component.css'
})
export class CancelTransferBookingComponent implements OnInit {
  organizationId: string = '';
  orderId: string = '';

  // Organization mapping based on orgId
  orgIdToSiteMap: { [key: string]: string } = {
    'A09630B0-C850-483F-9EAC-F5DB80D28893': 'mabi',
    '417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1': 'scandic',
    '5BF79F25-27BF-4B5B-AF83-B4A0233DAB70': 'apart-direct',
    'AC589E4E-5E38-4555-9BBF-AD4B1E2AD0DA': 'arlanda-xpo',
    '39218780-069A-4C6B-9925-22365A075C15': 'quality-xpo-hotel'
  };

  logoPath: string = '../../../assets/img/ParkiFly-logo.svg';
  transferOrg: string = 'Parkifly';
  isLoading: boolean = false;
  showThankYou: boolean = false;

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslocoService,
    private selfService: SelfServiceService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['orgId']) {
        this.organizationId = params['orgId'];
      }
      if (params['orderId']) {
        this.orderId = params['orderId'];
      }
      this.setLogoPath();
    });
  }

  setLogoPath(): void {
    const site = this.orgIdToSiteMap[this.organizationId] || '';

    switch (site) {
      case 'quality-xpo-hotel':
        this.logoPath = '../../../assets/img/quality-hotel-airport-arlanda.svg';
        this.transferOrg = 'Quality XPO Hotel';
        break;
      case 'mabi':
        this.logoPath = '../../../assets/img/mabi_logo_primary.png';
        this.transferOrg = 'Mabi';
        break;
      case 'scandic':
        this.logoPath = '../../../assets/img/Scandic_logo.svg';
        this.transferOrg = 'Scandic Hotel';
        break;
      case 'apart-direct':
        this.logoPath = '../../../assets/img/apartdirect.jpg';
        this.transferOrg = 'ApartDirect';
        break;
      case 'arlanda-xpo':
        this.logoPath = '../../../assets/img/arlandaxpoapartments.png';
        this.transferOrg = 'Arlanda XPO Apartments';
        break;
      default:
        this.logoPath = '../../../assets/img/ParkiFly-logo.svg';
        this.transferOrg = 'Parkifly';
    }
  }

  openCancelConfirmModal(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        text: {
          sv: 'Är du säker på att du vill avboka din transfer?',
          en: 'Are you sure you want to cancel your transfer?'
        },
        org: 'transfer'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cancelTransferBooking();
      }
    });
  }

  cancelTransferBooking(): void {
    this.isLoading = true;
    this.selfService.cancelByOrderId(this.orderId).then(
      (result) => {
        if (result.selfServiceResult == 3) {
          this.isLoading = false;
          const message = this.translate.translate('CANCEL_TRANSFER.CANCEL_SUCCESSFUL');
          this.snackBar.open(message, 'OK', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.router.navigate(['booking-service', this.organizationId]);
        } else {
          this.isLoading = false;
          const message = this.translate.translate('CANCEL_TRANSFER.CANCEL_FAILED');
          this.snackBar.open(message, 'OK', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      },
      (error) => {
        this.isLoading = false;
        const message = this.translate.translate('CANCEL_TRANSFER.CANCEL_FAILED');
        this.snackBar.open(message, 'OK', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    );
  }
}
